<div class="container mx-auto flex justify-between">
  <ul class="flex">
    <!--Regular Link-->
    @for (item of navList; track item; let i = $index) {
      <li
        class="navigation-main-li text-center"
      [ngClass]="
        item.label.trim() == ''
          ? ' w-min ' + navListStyle
          : ' w-max ' + navListStyle
      "
        >
        <a
          [routerLink]="[item.path]"
          (click)="getActiveClass(item)"
          class="navigation-main-anchor"
          [ngClass]="navAnchorStyle"
          [routerLinkActive]="activeLink"
          >
          @if (item && item.icon && item.icon.indexOf('.svg') != -1) {
            <img
              [src]="item.icon"
              class="inline -mt-1 h-5 w-5"
              [alt]="item.name || 'navigation icon'"
            />
          }
          @if (item && item.icon && item.icon.indexOf('.svg') == -1) {
            <img
              [src]="item.icon"
              class="inline -mt-1"
              />
          }
          {{ item.label }}</a
          >
        </li>
      }
    </ul>
  </div>
